import { getFromLocalStorage } from "../helpers/localStorage";
import { trpc } from "../helpers/trpc";

export const useLoggedOrganization = () => {
  const isConnectedOnDashboard = getFromLocalStorage?.("isConnectedOnDashboard") === "true";

  const { data: getUserTrpc, isFetched } = trpc.getFrontendCurrentUser.useQuery(undefined, {
    enabled: Boolean(isConnectedOnDashboard),
  });

  const loggedOrganization = getUserTrpc?.currentOrganization;
  const loggedUserId = getUserTrpc?.id;
  const isReady = !isConnectedOnDashboard || isFetched;

  return { loggedOrganization, loggedUserId, isReady, isConnectedOnDashboard };
};
